module.exports = __webpack_public_path__ + "img/The Library and meeting room.131c9fcf.png";